<template>
  <!--关于我们页面-->
  <div class="productPage">
    <!--图片-->
    <div class="imgBox">
      <div class="imageItem">
        <img :src="imgBoxUrl" class="el-image__inner">
      </div>
      <!--      <div class="imgText">
              <div>产品介绍</div>
              <div>YAG激光治疗仪YAG激光治疗仪YAG激光治疗仪YAG</div>
            </div>-->
    </div>

    <!--    导航-->
    <div class="num_all">
      <el-row >
        <el-col :span="18" :justify="end" ><div class="grid-content num_r">
          <el-menu :default-active="numIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item  v-for="item in numList" :index="item.num" :indexPath="item.path">{{item.tital}}</el-menu-item>
          </el-menu>
        </div></el-col>
      </el-row>
    </div>
    <!--    内容-->
    <div class="contentBox" v-show="showData.box1">
      <el-row :gutter="10" class="row_1">
        <el-col :span="6"><div class="grid-content"><p class="pp1">{{pptext.text1}}</p></div></el-col>
        <el-col :span="18"><div class="grid-content"><p class="pp2">{{pptext.text2}}</p></div></el-col>
      </el-row>
      <el-row :gutter="10" class="row_1">
        <el-col :span="6"><div class="grid-content"> </div></el-col>
        <el-col :span="18" :offset="6"><div class="grid-content"><p class="pp3">{{pptext.text3}}</p></div></el-col>
      </el-row>
      <div class="count3">
        <div class="p4" v-for="item in cpbuLsit" >
          <div class="p_top">
            <div class="sp1">{{item.text1}}</div>
            <div class="sp2">{{item.text2}}</div>
          </div>
          <div class="p_buttom">
            <div class="sp3">{{item.text3}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="contentBox"  v-show="showData.box2">
      <el-timeline>
        <el-timeline-item placement="top" v-for="item in c2DataList">
          <div>
            <p class="c2_p1">{{item.text1}}</p>
            <p class="c2_p2">{{item.text2}}</p>
            <p class="c2_p3"  v-if="item.text3 != ''">{{item.text3}}</p>
            <el-image
              v-if="item.url != ''"
              style="width: 360px; height: 180px"
              :src="item.url"
              :fit="contain"></el-image>
          </div>
        </el-timeline-item>

      </el-timeline>
    </div>

    <div class="contentBox" v-show="showData.box3" >

      <div class="count_3">
        <p class="c3_p1" v-for="item in c3Data.c3P">{{item.text1}}</p>
      </div>
      <div class="count3">
        <div class="p4" v-for="item in c3Data.c3w" >
          <div class="p_top">
            <div class="sp1">{{item.text1}}</div>
            <div class="sp2">{{item.text2}}</div>
          </div>
          <div class="p_buttom">
            <div class="sp3">{{item.text3}}</div>
          </div>
        </div>
      </div>
      <div class="c3_img" v-for="itemall in c3Data.c3Img">
        <div class="c3_img2" v-for="item in  itemall.imgItem">
          <el-image
            style="width: 376px; height: 483px"
            :src="item.url"
            :fit="contain"></el-image>
          <p v-if="item.text1 != ''" class="c3_p2">{{item.text1}}</p>
        </div>
      </div>
    </div>

    <div class="contentBox"  v-show="showData.box4">
      <div class="c4_ren" v-for="item in c4Data">
        <div class="c4_ren_img">
          <el-image
            style="width: 384px; height: 360px"
            :src="item.imgUrl"
            :fit="contain"></el-image>
        </div>
        <div class="c4_ren_text">
          <div class="c4_ren_d1">
            <p class="C4_p1">{{item.text1}}</p>
          </div>
          <div>
            <p class="C4_p2">{{item.text2}}</p>
            <p class="C4_p2">{{item.text3}}</p>
            <p class="C4_p2">{{item.text4}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="contentBox" v-show="showData.box5">
      <div class="c5_sm" v-for="item in c5Data">
        <div class="c5_sm_1">
          <div class="c5_sm_p1">{{item.text1}}</div>
          <div class="c5_sm_p2">{{item.text2}}</div>
        </div>
      </div>
    </div>
    </div>
</template>

<script>

export default {
  name: "product",
  data() {
    return {
      imgBoxUrl:"http://116.62.38.250//image//nr/tp/gywm.jpg",
      urlData:"",
      showData:{
        box1: false,
        box2: false,
        box3: false,
        box4: false,
        box5: false
      },
      numIndex: "1",
      numList : [
        {
          num : "1",
          tital : "Company Profile",
          path: "ggjj"
        },
        {
          num : "2",
          tital : "Development History",
          path: "fzlc"
        },
        {
          num : "3",
          tital : "Core Advantages",
          path: "hxys"
        },
        // {
        //   num : "4",
        //   tital : "团队成员",
        //   path: "tdcy"
        // },
        {
          num : "5",
          tital : "Vision & Mission",
          path: "yjsm"
        }
      ],
      pptext:{
        text1 : "Company Profile",
        text2 : "Micro-Innovation (Beijing) Laser Technology Co., Ltd., established in 2014, brings a wealth of experience and cutting-edge technology to the field of dental lasers. As a national high-tech enterprise, the company operates two production bases in Beijing and Suzhou, with extensive technological resources focused on the research, development, production, and commercialization of a full range of dental laser treatment devices and consumables.",
        text3: "On March 21, 2024, Micro-Innovation's flagship product, the VICTRUM Er:YAG Laser System, officially received the NMPA Class III Medical Device Registration Certificate (Registration Code: 20243010581), marking its domestic market debut as China's first Erdental laser device. This milestone fills a significant gap in the Chinese dental laser market.\n" +
          "The clinical trials for the VICTRUM Er:YAG Laser were successfully completed in October 2022 at Capital Medical University Xuanwu Hospital and the China-Japan Friendship Hospital. The company's R&D team consists of top-tier talent from institutions such as Peking University School of Stomatology, Shanghai Jiao Tong University, and military laser experts. Micro-Innovation has overcome significant technological barriers, establishing a comprehensive intellectual property portfolio with over 80 related patents, placing its product technology at the forefront of the global market.\n" +
          "The company also boasts a nationwide pre-sales and after-sales service network, with major regional service centers that provide comprehensive clinical technical support and maintenance services to dental professionals across China.\n" +
          "The VICTRUM Er:YAG Laser represents a revolutionary advancement in dental laser technology, much like how mobile phones freed the world from traditional landlines. The \"laser-in-handle\" technology solves the persistent technical challenges associated with  Er:YAG lasers that rely on fiber or articulated arms, such as large device size, energy transmission loss, operational inconvenience, and high maintenance costs. This breakthrough paves the way for widespread adoption of  Er:YAG lasers, enabling dentists to operate the laser with the ease and familiarity of a high-speed turbine handpiece."
      },
      cpbuLsit : [
        {
          text1 : "10",
          text2 : "TH",
          text3: "Established in 2014"
        },
        {
          text1 : "80",
          text2 : "+",
          text3: "Intellectual Property Rights"
        },
        // {
        //   text1 : "10",
        //   text2 : "+",
        //   text3: "10多个出口国家"
        // },
        {
          text1 : "20",
          text2 : "+",
          text3: "Core R&D Engineers"
        }
      ],
      c2DataList : [
        {
          text1:"2014",
          text2:"the company was established and initiated the development of the Er:YAG dental laser treatment system.",
          text3:"",
          url:""
        },
        {
          text1:"2017",
          text2:"the first domestic simulation model of the Er:YAG dental laser treatment system was completed.",
          text3:"",
          url:""
        },
        {
          text1:"2019",
          text2:"the first functional model of the domestic Er:YAG dental laser treatment system was completed.",
          text3:"",
          url:""
        },
        {
          text1:"2020",
          text2:"the prototype of the first domestic Er:YAG dental laser treatment system passed the national type inspection.",
          text3:"",
          url:""
        },
        {
          text1:"April 2021",
          text2:"the Er:YAG dental laser passed the ethics review of the Capital Medical University Xuanwu Hospital.",
          text3:"",
          url:""
        },
        {
          text1:"October 2022",
          text2:"the clinical trials for the Er:YAG dental laser treatment system were completed.",
          text3:"",
          url:""
        },
        {
          text1:"February 2023",
          text2:"the Er:YAG dental laser treatment system received the acceptance notice from the National Medical Products Administration (NMPA).",
          text3:"",
          url:""
        },
        {
          text1:"March 22, 2024",
          text2:"the first domestic NMPA registration certificate for the Er:YAG dental laser treatment system was issued.",
          text3:"",
          url:""
        },
        {
          text1:"June 2024",
          text2:"the company participated in establishing the industry standard for \"Fiber-Free Transmission Technology in Er:YAG Laser Clinical Applications.",
          text3:"",
          url:""
        }
      ],
      c3Data:{
        c3P:[
          {
            text1:"· High-end Equipment, Made in China"
          },
          {
            text1:"· The first domestic Er:YAG dental laser treatment system."
          },
          {
            text1:"· Innovative \"Laser-in-Handle\" Technology: This patented design eliminates expensive and fragile fiber optics and significantly improves the articulated arm laser transmission system."
          }

        ],
        c3w:[
          {text1 : "80",
            text2 : "+",
            text3: "Intellectual Property Rights"},
          {
            text1 : "20",
            text2 : "+",
            text3: "Core R&D Engineers"
          }
          // ,
          // {
          //   text1 : "10",
          //   text2 : "+",
          //   text3: "10多个出口国家"
          // },
          // {text1 : "10",
          //   text2 : "+",
          //   text3: "10多个出口国家"}
        ],
        c3Img:[
          {
            imgItem:[
              {
                url:"http://116.62.38.250//image/nr/gywm/1.png",
                text1:""
              },
              {
                url:"http://116.62.38.250//image/nr/gywm/2.png",
                text1:""
              },
              {
                url:"http://116.62.38.250//image/nr/gywm/3.png",
                text1:""
              }
            ]
          },
          {
            imgItem:[
              {
                url:"http://116.62.38.250//image/nr/gywm/4.jpg",
                text1:""
              },
              {
                url:"http://116.62.38.250//image/nr/gywm/5.png",
                text1:""
              },
              {
                url:"http://116.62.38.250//image/nr/gywm/6.png",
                text1:""
              }
            ]
          }
        ]
      },
      c4Data:[
        {
          imgUrl:"https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          text1:"张三",
          text2:"XX自2012年2月起担任CASI公司董事会主席，2018年2月起担任董事会执行主席，从2019年起兼任首席执行官。加入XX之前，XXX科技有限公司董事会主席兼首席执行官",
          text3:"XXX博士是ETP基金创始人、合伙人，ETP是一家专注于生命科学领域的风险投资公司，成立于2000年。在职业生涯中，何博士创立或投资了超过100余家生物技术公司，其中包括数家独角兽企业。",
          text4:"在职业生涯的早期，XXX是人类基因编组的首批科学家。在此之前他曾在哈佛麻省总院和梅奥医学中心做博士后研究。发表了超过30篇研究文献，并且是32项专利的发明人。他拥有贝勒医学院分子生物学博士，并获得沃顿商学院的MBA学位。"
        },
        {
          imgUrl:"https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          text1:"李四",
          text2:"XX自2012年2月起担任CASI公司董事会主席，2018年2月起担任董事会执行主席，从2019年起兼任首席执行官。加入XX之前，XXX科技有限公司董事会主席兼首席执行官",
          text3:"XXX博士是ETP基金创始人、合伙人，ETP是一家专注于生命科学领域的风险投资公司，成立于2000年。在职业生涯中，何博士创立或投资了超过100余家生物技术公司，其中包括数家独角兽企业。",
          text4:"在职业生涯的早期，XXX是人类基因编组的首批科学家。在此之前他曾在哈佛麻省总院和梅奥医学中心做博士后研究。发表了超过30篇研究文献，并且是32项专利的发明人。他拥有贝勒医学院分子生物学博士，并获得沃顿商学院的MBA学位。"
        },
        {
          imgUrl:"https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          text1:"李四",
          text2:"XX自2012年2月起担任CASI公司董事会主席，2018年2月起担任董事会执行主席，从2019年起兼任首席执行官。加入XX之前，XXX科技有限公司董事会主席兼首席执行官",
          text3:"XXX博士是ETP基金创始人、合伙人，ETP是一家专注于生命科学领域的风险投资公司，成立于2000年。在职业生涯中，何博士创立或投资了超过100余家生物技术公司，其中包括数家独角兽企业。",
          text4:"在职业生涯的早期，XXX是人类基因编组的首批科学家。在此之前他曾在哈佛麻省总院和梅奥医学中心做博士后研究。发表了超过30篇研究文献，并且是32项专利的发明人。他拥有贝勒医学院分子生物学博士，并获得沃顿商学院的MBA学位。"
        },
        {
          imgUrl:"https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          text1:"李四",
          text2:"XX自2012年2月起担任CASI公司董事会主席，2018年2月起担任董事会执行主席，从2019年起兼任首席执行官。加入XX之前，XXX科技有限公司董事会主席兼首席执行官",
          text3:"XXX博士是ETP基金创始人、合伙人，ETP是一家专注于生命科学领域的风险投资公司，成立于2000年。在职业生涯中，何博士创立或投资了超过100余家生物技术公司，其中包括数家独角兽企业。",
          text4:"在职业生涯的早期，XXX是人类基因编组的首批科学家。在此之前他曾在哈佛麻省总院和梅奥医学中心做博士后研究。发表了超过30篇研究文献，并且是32项专利的发明人。他拥有贝勒医学院分子生物学博士，并获得沃顿商学院的MBA学位。"
        }

      ],
      c5Data:[
        {
          text1:"Corporate Vision",
          text2: "To become the global leader in dental laser products."
        },
        {
          text1:"Corporate Mission",
          text2: "To provide patients with comfortable, fear-free dental care and help doctors deliver safe and efficient treatments."
        },
        {
          text1:"Corporate Values",
          text2: "Exceed customer expectations and empower core employees."
        }
      ]
    }
  },
  created() {
    let that = this;
    that.urlData = that.$route.query.path;
    console.log(that.urlData);

  },
  mounted() {
    let that = this;
    console.log("init");
    that.init();
  },
  methods: {
    init(){
      let that = this;
      console.log(that.urlData);
      console.log(that.urlData == undefined);
      if(that.urlData == "" || that.urlData == undefined){
        that.handleSelect("1",'gsjj')
      } else {
        let index = "1";
        if(that.urlData == 'gsjj'){
          index = "1";
        } else if (that.urlData == 'fzlc'){
          index = "2";
        } else if (that.urlData == 'hxys'){
          index = "3";
        } else if (that.urlData == 'tdcy'){
          index = "4";
        } else if (that.urlData == 'yjsm'){
          index = "5";
        }

        that.handleSelect(index,that.urlData)
      }

    },

    handleSelect(index, path) {
      let that = this;
      that.numIndex = index;
      console.log(index+path)  //获取tab标签的选中值
      console.log(index, path);
      //初始化
      that.showData.box1 = false;
      that.showData.box2= false;
      that.showData.box3 = false;
      that.showData.box4 = false;
      that.showData.box5 = false;

      if(index == '1'){
        that.showData.box1 = true;
      } else if (index == '2'){
        that.showData.box2 = true;
      } else if (index == '3'){
        that.showData.box3 = true;
      } else if (index == '4'){
        that.showData.box4 = true;
      } else if (index == '5'){
        that.showData.box5 = true;
      }
    }
  }

}
</script>

<style scoped>
.num_all{
  background: #ffffff;
  font-family: SourceHanSansCN;
  font-size: 12px;
  text-align: justify;
  height: 60px;
  width: 100%;
}
.num_r{
  float: right;
}
.c5_sm_p1{
  font-family: SourceHanSansCN;
  font-size: 24px;
  text-align: left;
}
.c5_sm_p2{
  font-family: SourceHanSansCN;
  font-size: 14px;
  letter-spacing: 0;
  text-align: justify;
  line-height: 20px;
}
.c5_sm_1{
  width: 685px;
  height: 64px;
  margin-left: 30px;

}
.c5_sm{
  width: 1176px;
  height: 148px;
  background-color: #FFFFFF;
  border-left: 3px solid #5daf34 ;
  margin-bottom: 100px;
  display: flex;
  align-items: center;
}
.c4_ren_d1{
  margin-bottom: 20px;
}
.C4_p1{
  font-family: SourceHanSansCN;
  font-size: 24px;
  text-align: left;
}
.C4_p2{
  font-family: SourceHanSansCN;
  font-size: 14px;
  letter-spacing: 0;
  text-align: justify;
  margin-bottom: 5px;
}
.c4_ren_text{
  width: 663px;
  height: 253px;
  margin: 50px auto;
}
.c4_ren{
  display: flex;
  width: 1176px;
  height: 360px;
  margin-bottom: 50px;
  border:1px #a6a9ad solid;
}
.c3_img2{
  margin-right: 15px;
}
.c3_img{
  display: flex;
}
.count_3{
  width: 1176px;
  height: 125px;
}
.c3_p2{
  font-family: SourceHanSansCN;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0.3px;
  text-align: center;
}
.c3_p1{
  font-family: SourceHanSansCN;
  font-size: 18px;
  letter-spacing: 0.39px;
  text-align: left;
  margin-top: 10px;
}
.c2_p1{
  font-family: SourceHanSansCN;
  font-size: 36px;
  color: #63B62E;
  letter-spacing: 0.77px;
  text-align: left;
}
.c2_p2{
  font-family: SourceHanSansCN;
  font-size: 18px;
  color: #333333;
  letter-spacing: 0.39px;
  text-align: left;
}
.c2_p3{
  font-family: SourceHanSansCN;
  font-size: 14px;
  color: #999999;
  letter-spacing: 0.3px;
  text-align: left;
}
.p4{
  width: 171px;
  height: 152px;
  margin-right: 100px;
}
.p_top{
  display: flex;
}
.count3{
  display: flex;
  margin-top: 100px;
}
.sp1{
  font-family: SourceHanSansCN;
  font-size: 100px;
  color: #63B62E;
  letter-spacing: 2.14px;
  text-align: justify;
}
.c3_img{
  margin-top: 50px;
}
.sp2{
  font-family: SourceHanSansCN;
  font-size: 40px;
  color: #63B62E;
  letter-spacing: 0.86px;
  text-align: justify;
}
.sp3{
  font-family: SourceHanSansCN;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0.3px;
  text-align: center;
}
.row_1{
  margin: 30px auto;
}
.p1{
  width: 30%;
  margin: 50px auto;
  justify-content: start; /* 水平居中 */
  align-items: start;
}
.pp1{
  font-family: SourceHanSansCN;
  font-size: 30px;
  text-align: justify;
}
.pp2{
  font-family: SourceHanSansCN;
  font-size: 14px;
  letter-spacing: 0.3px;
  text-align: justify;
}
.pp3{
  font-family: SourceHanSansCN;
  font-size: 12px;
  color: #666666;
  letter-spacing: 0.2px;
  text-align: justify;
  line-height: 24px;
}
.productPage {
  display: block;
  width: 1920px;
  background-color: #FFFFFF;
  margin-left: auto;
  margin-right: auto;
}

.imgBox {
  width: 100%;
  height: 600px;
}

.imageItem {
  height: 100%;
}



.contentBox {
  width: 1176px;
  margin: 50px auto;
}
.count1{
  width: 70%;
  height: 100px;
  display: flex;

}


</style>



// WEBPACK FOOTER //
// src/components/en/aboutUs.vue